// The signed-in user's id, decoded from the access token's `id` claim. This
// is reliable across every login path (direct login, signup, org-switch),
// unlike `auth.userId` — the app only ever dispatches `setTokens`, never
// `setAuth`.
export const currentUserId = (): string | null => {
  try {
    const payload = localStorage.getItem('accessToken')?.split('.')[1];
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof json?.id === 'string' ? json.id : null;
  } catch {
    return null;
  }
};
